import { MouseEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSpacePath } from '../../../hooks/useSpacePath';
import { isPlainLeftClick } from '../../../utils/isPlainLeftClick';
import { usePermissions } from '../../../hooks/usePermissions';
import { QuoteCompaisonGroupDatabase } from '../../../types';
import { useGetQuoteGroups } from '../api/useGetQuoteGroups';

export function useQuoteGroupsPage() {
  const { isAdmin } = usePermissions();
  const navigate = useNavigate();
  const spacePath = useSpacePath();
  const [isFormOpen, setIsFormOpen] = useState(false);
  const groupsQuery = useGetQuoteGroups();
  const groups = groupsQuery.data ?? [];

  function getHref(groupId: string) {
    return spacePath(`/quotes/${groupId}`);
  }

  function handleOpenGroup(event: MouseEvent<HTMLElement>, groupId: string) {
    if (!isPlainLeftClick(event)) {
      return;
    }

    event.preventDefault();
    navigate(getHref(groupId));
  }

  function handleGroupCreated(group: QuoteCompaisonGroupDatabase) {
    navigate(getHref(group.id));
  }

  return {
    isAdmin,
    groups,
    isLoading: groupsQuery.isPending,
    isError: groupsQuery.isError,
    isFormOpen,
    subtitle: groups.length > 0
      ? `${groups.length} comparaison${groups.length > 1 ? 's' : ''}`
      : 'Comparez vos devis critère par critère avant de décider',
    getHref,
    handleOpenGroup,
    handleGroupCreated,
    handleRetry: () => groupsQuery.refetch(),
    handleOpenForm: () => setIsFormOpen(true),
    handleCloseForm: () => setIsFormOpen(false),
  };
}
